var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgYii(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56.165,
    height: 69.292,
    viewBox: "0 0 56.165 69.292",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.41,
    x2: 0.5,
    y2: 2.248,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.302
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "yii-stop",
    transform: "translate(0.002 -0.167)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_242",
    "data-name": "Ellipse 242",
    cx: 2.808,
    cy: 2.814,
    rx: 2.808,
    ry: 2.814,
    transform: "translate(25.273 63.83)",
    fill: "#07d4bf"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1999",
    "data-name": "Path 1999",
    d: "M23.6,70.279C10.218,69.335,0,64.226,0,58.068,0,51.238,12.573,45.7,28.081,45.7s28.081,5.538,28.081,12.367c0,6.14-10.162,11.232-23.485,12.2-3.894.8-4.6,2.64-4.6,2.64a7.949,7.949,0,0,0-4.48-2.629Z",
    transform: "translate(0 -10.016)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2000",
    "data-name": "Path 2000",
    d: "M23.6,55.969a28.081,28.081,0,1,1,9.076-.019,8.707,8.707,0,0,0-4.6,6S26.307,56.919,23.6,55.969Z",
    fill: "#07d4bf",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "yii",
    transform: "translate(261.273 -531.847)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_459",
    "data-name": "Path 459",
    d: "M-179.88,555.8c-1.706.062-3.76,2.2-3.062,4.192a16.387,16.387,0,0,1,1.336,5.569c1.788-1.808,3.432-3.76,3.576-6.041a3.944,3.944,0,0,0-1.849-3.719Z",
    transform: "translate(-48.4 -3.734)",
    fill: "#a0e4d5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_460",
    "data-name": "Path 460",
    d: "M-219.6,576.707a5.268,5.268,0,0,1-3.822,2.158l-.39.041-.041-.39a7.888,7.888,0,0,1,1.685-5.733,10.792,10.792,0,0,0,1.253-1.911h0c-.308-.144-.637-.288-.986-.411-1.007-.37-1.911-.6-3.226-.986a4.942,4.942,0,0,1-3.74-5.322,6.64,6.64,0,0,1,2.4-.452h0a7.193,7.193,0,0,1,5.754,3.041c.205.288.411.575.6.884a12.6,12.6,0,0,1,1.6,4.274c.041.247.082.493.1.74v.185A6.717,6.717,0,0,1-219.6,576.707Z",
    transform: "translate(-12.014 -10.011)",
    fill: "#a0e4d5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_303",
    "data-name": "Group 303",
    transform: "translate(-243.672 551.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_461",
    "data-name": "Path 461",
    d: "M-180.221,552.148a4.516,4.516,0,0,1,1.664,3.843c-.123,2.034-1.356,3.945-2.918,5.713a26.966,26.966,0,0,0-1.6-5.425,2.79,2.79,0,0,1,.452-2.445,4.089,4.089,0,0,1,2.4-1.685Zm.226-1.048c-2.26.082-4.993,2.918-4.048,5.548a21.8,21.8,0,0,1,1.767,7.4c2.384-2.4,4.562-4.993,4.747-8.014a5.341,5.341,0,0,0-2.466-4.932Z",
    transform: "translate(196.188 -551.1)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_302",
    "data-name": "Group 302",
    transform: "translate(13.337 11.487)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_462",
    "data-name": "Path 462",
    d: "M-177.377,607.945c-.041-.308-.082-.616-.123-.945l.021.123A7.443,7.443,0,0,1-177.377,607.945Z",
    transform: "translate(177.5 -607)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_463",
    "data-name": "Path 463",
    d: "M-176.9,611.6v.226a.02.02,0,0,0,.021.021C-176.879,611.764-176.9,611.682-176.9,611.6Z",
    transform: "translate(190.36 -599.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_464",
    "data-name": "Path 464",
    d: "M-228.943,567.413v-.226c-.041-.308-.082-.616-.123-.945a16.528,16.528,0,0,0-2.055-5.486c-.247-.391-.493-.781-.76-1.151a9.287,9.287,0,0,0-7.4-3.9v1.027a8.214,8.214,0,0,1,6.555,3.493,11.907,11.907,0,0,1,.7,1.069,15.247,15.247,0,0,1,1.48,3.349c-.226-.144-.452-.267-.678-.39a15.919,15.919,0,0,0-1.849-.822c-.966-.349-1.87-.616-2.939-.925-.39-.1-.822-.226-1.274-.37h-.021a5.243,5.243,0,0,1-4.069-5.1,7.152,7.152,0,0,1,2.075-.308V555.7h0a8.214,8.214,0,0,0-3.082.6,6.333,6.333,0,0,0,4.808,6.822c1.685.493,2.856.8,4.151,1.274.452.164.863.329,1.253.514h0a12.482,12.482,0,0,1-1.6,2.466,10.11,10.11,0,0,0-2.178,7.377l.062.493.493-.062a6.789,6.789,0,0,0,4.911-2.774A8.425,8.425,0,0,0-228.943,567.413Zm-2.363,4.418a5.6,5.6,0,0,1-3.658,2.281,9.073,9.073,0,0,1,2.014-6.082,14.171,14.171,0,0,0,1.706-2.63,8.535,8.535,0,0,1,1.089.76l.1.432A7.416,7.416,0,0,1-231.306,571.831Z",
    transform: "translate(242.403 -554.755)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYii);
export default __webpack_public_path__ + "static/media/yii.f9d5007a35a7ec5450efe7d43100a404.svg";
export { ForwardRef as ReactComponent };